<template>
  <div>
    <b-nav pills class="mb-3">
      <b-nav-item :to="{name: 'player_seasons'}" active-class="active-underline">
        Сезоны
      </b-nav-item>
      <b-nav-item :to="{name: 'player_gvnts'}" active-class="active-underline">
        Игровые события
      </b-nav-item>
      <b-nav-item :to="{name: 'player_contests'}" active-class="active-underline">
        Конкурсы
      </b-nav-item>
      <b-nav-item :to="{name: 'player_rushes'}" active-class="active-underline">
        Ражи
      </b-nav-item>
      <b-nav-item :to="{name: 'player_derbies'}" active-class="active-underline">
        Скачки
      </b-nav-item>
      <b-nav-item :to="{name: 'player_regattas'}" active-class="active-underline">
        Регаты
      </b-nav-item>
      <b-nav-item :to="{name: 'player_mesas'}" active-class="active-underline">
        Месы
      </b-nav-item>

      <!--
      Скачки
      Регаты
      Ражи
      Месы
      Кувшинки
      -->
    </b-nav>

    <router-view></router-view>
  </div>
</template>

<script>
export default {
  name: 'PlayerEvents',
};
</script>

<style scoped>
a {
  padding: 0;
  margin-right: 0.7rem;
}
a.active-underline {
  pointer-events: none;
  border-bottom: 0.2rem solid #007bff;
  border-radius: 0;
}
</style>
